/* ============================================================
   Chimney Direct — expand/collapse-all for the guide accordion.

   The accordion itself is native <details>; this only adds the bulk
   toggle, so with JS off every chapter still opens and closes.
   ============================================================ */
(function () {
  'use strict';

  class ChimneyAccordion extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.button = this.querySelector('[data-accordion-toggle-all]');
      if (!this.button) return;

      this.button.hidden = false;
      this.button.addEventListener('click', this.onToggleAll.bind(this));
      /* A chapter opened or closed on its own puts the button out of step. */
      this.addEventListener('toggle', this.syncButton.bind(this), true);
      this.syncButton();
    }

    get items() {
      return Array.from(this.querySelectorAll('details'));
    }

    onToggleAll() {
      var expand = this.button.getAttribute('aria-expanded') !== 'true';
      this.items.forEach(function (item, index) {
        /* Exclusive accordions (<details name>) close their siblings, so only
           the last one would survive an expand-all. Keep the first instead. */
        item.open = expand && (!item.name || index === 0);
      });
      this.syncButton();
    }

    syncButton() {
      if (!this.button) return;
      var items = this.items;
      var allOpen = items.length > 0 && items.every(function (item) {
        return item.open;
      });
      this.button.setAttribute('aria-expanded', String(allOpen));
    }
  }

  if (!customElements.get('chimney-accordion')) {
    customElements.define('chimney-accordion', ChimneyAccordion);
  }
})();
